'use client';

import Link from 'next/link';
import type { PropertyListItem } from 'src/redux/properties/types';

/**
 * Figma 8013:98714's columns (340, 160, 130, 120, 190 of 1178; the newer list frames replace
 * 4422:20038's 150 and 100), as shares of the table so the last column keeps room for "Property
 * Manager" on one line on a narrower window.
 */
export const PROPERTY_LIST_COLUMN_WIDTHS = {
  address: 'w-[28.9%]',
  market: 'w-[13.6%]',
  type: 'w-[11.05%]',
  openSrs: 'w-[10.2%]',
  lastServiced: 'w-[16.1%]',
} as const;

/** Street over city, state and ZIP. The link is the keyboard path; the row click is mouse-only. */
export const PropertyAddressCell = ({ row }: { row: PropertyListItem }) => {
  const cityState = [row.city, row.state_code].filter(Boolean).join(', ');
  return (
    <div className="flex flex-col">
      <Link
        href={`/properties/${row.property_uuid}`}
        className="desktop-body-md-base text-text-primary no-underline"
        onClick={(event) => event.stopPropagation()}
      >
        {row.street_address}
      </Link>
      <span className="desktop-body-sm text-text-secondary">
        {[cityState, row.postal_zip_code].filter(Boolean).join(' ')}
      </span>
    </div>
  );
};

/** "Unassigned" reads quieter than a market name. */
export const PropertyMarketCell = ({ name }: { name?: string | null }) =>
  name ? <span>{name}</span> : <span className="text-text-secondary">Unassigned</span>;
